import React from 'react';
import { Grid } from 'semantic-ui-react';
import CatalogueTitle from './CatalogueTitle';
import CataloguePanelContainer from './CataloguePanelContainer';
import DatasetSubscribeAction from '../../subscriptions/components/DatasetSubscribeAction';
import DatasetVisibilityLabel from '../../components/DatasetVisibilityLabel';
import DatasetCatalogueAccordion from './DatasetCatalogueAccordion';
import Selectors from '../hooks/selectors';

const CataloguePanelNarrow = ({ category, code, onChange }) => {
  const state = Selectors.useCataloguePanel({ category, code });
  return (
    <CataloguePanelContainer
      category={category}
      className="aridhia-catalogue-panel-narrow overflow-x-hidden"
      code={state.code}
      onChange={onChange}
    >
      <Grid>
        <Grid.Row>
          <Grid.Column width={10}>
            <CatalogueTitle code={state.code} category={category} errorCoordinate="t-45" />
          </Grid.Column>
          <Grid.Column width={6} textAlign="right">
            <DatasetVisibilityLabel visibility={state.visibility} code={state.code} allowManage={state.allowManage} />
            {state.canSubscribe && <DatasetSubscribeAction code={state.code} category={category} />}
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <DatasetCatalogueAccordion category={category} code={state.code} url={state.url} />
    </CataloguePanelContainer>
  );
};

export default CataloguePanelNarrow;
